export default __webpack_public_path__ + "images/396e095f767a1071961a1c38aa240e75.svg";